// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "grafana." + {"1135":"light","3588":"dark"}[chunkId] + "." + __webpack_require__.h() + ".css";
};